import { render, staticRenderFns } from "./editRule.vue?vue&type=template&id=0472ff90&"
import script from "./editRule.vue?vue&type=script&lang=tsx&"
export * from "./editRule.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports